import API from 'services/TAPS_API';

export default function removeCertificate(payload) {
  return API.request({
    method: payload.data ? 'POST' : 'GET',
    url: `/certificate/${payload.revokeType}`,
    data: payload.data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
